<template>
  <s-modal-card :accept="accept" :cancel="cancel">
    <template slot="title">
      Confirm
    </template>
    <div slot="body">Are you sure?</div>
  </s-modal-card>
</template>

<script type="text/babel">
export default {
  name: 'confirm',
  data() {
    return {
      accept: {
        text: 'Yes',
        fn: () => {
          this.dialogClose(true)
        },
      },
      cancel: {
        text: 'Cancel',
        fn: () => {
          this.dialogClose(false)
        },
      },
    }
  },
  props: ['dialogClose'],
}
</script>
